import { useLayoutEffect } from 'react';
import { useGetStartedTour } from './GetStartedTour.context';

/**
 * Holds the "Get started" coachmark back while a surface's own onboarding owns the screen.
 *
 * The accommodations page opens its hotel-picks modal on first visit, which would otherwise share
 * the screen with the tour's step-4 coachmark. The rule: whoever the user has not seen yet goes
 * first, and the coachmark waits until that modal is completed or dismissed — never both at once.
 *
 * The hold releases automatically on unmount, so a surface can never strand the tour. Registering
 * in a layout effect means the hold is in place before the browser paints the frame the suppressing
 * surface mounted on — a passive effect lets the coachmark flash for that frame.
 */
export const useSuppressGetStartedCoachmark = (key: string, isSuppressed: boolean): void => {
  const { setCoachmarkSuppressed } = useGetStartedTour();

  useLayoutEffect(() => {
    setCoachmarkSuppressed(key, isSuppressed);
    return () => setCoachmarkSuppressed(key, false);
  }, [key, isSuppressed, setCoachmarkSuppressed]);
};
